import { CapitalsResponse } from "../api/request/Lead/Interfaces/DataInterface.response";

/**
 * Keeps only the capitals the lead actually contracted (`active: true`).
 * Same filter `/api/pricing/capitals` applies server-side, so the payment
 * page can work from `/api/lead/payment` capitals for markets that do not
 * call the pricing endpoint (IT, FR).
 */
export const activeCapitalsFrom = (
  capitals: CapitalsResponse | null | undefined
): CapitalsResponse => {
  if (!capitals) return {};
  const result: CapitalsResponse = {};
  for (const [trait, entry] of Object.entries(capitals)) {
    if (entry?.active) {
      result[trait as keyof CapitalsResponse] = entry;
    }
  }
  return result;
};

export const hasActiveCapitals = (
  capitals: CapitalsResponse | null | undefined
): boolean => Object.keys(activeCapitalsFrom(capitals)).length > 0;
